import React from 'react';
import Layout from '@app/layouts/_layout';
import RadialGradient from '@app/components/ui/radial-gradient';
import VacancyRow from '@app/components/ui/vacancy-row';
import { ILayoutProps } from '@app/models/props/home';
import { CareerAttributes, VacancyDto } from '@app/models/dtos/strapi';
import { getLayoutProps, getCareerContent, getVacanciesContent } from '@app/utils/serverSidePropsUtils';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';

interface IOpeningsPageProps extends ILayoutProps {
    career: CareerAttributes | null;
    vacancies: Array<VacancyDto>;
}

export async function getServerSideProps({ locale }: any) {
    const [layoutProps, career, vacancies] = await Promise.all([getLayoutProps(), getCareerContent(), getVacanciesContent()]);
    if (!vacancies) {
        return {
            notFound: true
        };
    }
    return {
        props: {
            ...layoutProps,
            career,
            vacancies,
            ...(await serverSideTranslations(locale, ['common'], null, ['en', 'nl']))
        }
    };
}

function CareerOpenings({ locations, settings, products, socialMedias, vacancies, career }: IOpeningsPageProps) {
    return (
        <Layout locations={locations} settings={settings} products={products} socialMedias={socialMedias} childClassName="py-[60px] flex w-full flex-col items-center md:py-[160px]">
            <RadialGradient />
            <div className="container w-full">
                <p className="P2 !text-black-1 ">Career</p>
                <p className="h3-responsive my-2 max-w-[786px] text-black-1 md:my-4">Find Your Role</p>
                <p className="P1 max-w-[786px] !text-black-2">Explore open positions and jump directly into the role details.</p>
                <div className="mt-[20px] w-full md:mt-[32px]">
                    <p className="P2 mb-[20px] !text-black-1" dangerouslySetInnerHTML={{ __html: career?.openingTitle || 'Openings' }} />
                    {vacancies.length === 0 ? (
                        <div className="rounded-[8px] bg-[#f2f2f2] px-[20px] py-[24px] text-center">
                            <p className="P1 !text-black-2">No current openings</p>
                        </div>
                    ) : (
                        vacancies.map((vacancy) => <VacancyRow key={vacancy.id} vacancy={vacancy} />)
                    )}
                </div>
            </div>
        </Layout>
    );
}

export default CareerOpenings;
